


























import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system";
import { ICheckStyle } from "../../../../domain/format/objects";
import { CheckStyleKinds, Color } from "../../../../../../domain/drawing";
import { ColorPicker } from "../../../../../base/components/drawing";
import { OptionDropDownSelector } from "../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../base/components/system/selectors/mixins";
import { default as OptionalFeatureEditor } from "./OptionalFeatureEditor.vue";

@Component({
  components: {
    colorPicker: ColorPicker,
    OptionDropDownSelector,
    OptionalFeatureEditor,
  },
})
export default class CheckStyleEditor extends Mixins(ModelEditableMixin) {
  @Prop()
  pallet: Color[];

  @Prop()
  colorDescription: string;

  @Prop({default: () => ({
    kind: {
      isEnable: true,
    },
    paint: {
      isEnable: true,
    },
    border: {
      isEnable: true,
    },
  })})
  option: {
    kind: {
      isEnable: boolean;
    },
    paint: {
      isEnable: boolean;
    },
    border: {
      isEnable: boolean;
    },
  };

  writePropertyWhenValid: (writer: (source: ICheckStyle) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ICheckStyle) => T, defaultValue: T) => T;

  get kind(): CheckStyleKinds {
    return this.readPropertyOrDefault(s => s.kind, CheckStyleKinds.Fill);
  }

  set kind(value: CheckStyleKinds) {
    this.writePropertyWhenValid(s => s.kind = value);
  }

  get isColorSelectable(): boolean {
    return this.readPropertyOrDefault(s => s.paint.isEnable, false);
  }

  set isColorSelectable(value: boolean) {
    this.writePropertyWhenValid(s => s.paint.isEnable = value);
  }

  get paint(): Color {
    return this.readPropertyOrDefault(s => Color.from(s.paint.color), new Color("#ffffff"));
  }

  set paint(value: Color) {
    this.writePropertyWhenValid(s => s.paint.color = Color.to(value));
  }

  get defaultColor(): Color {
    return new Color("#ffffff");
  }

  get border(): boolean {
    return this.readPropertyOrDefault(s => s.border.isEnable, true);
  }

  set border(value: boolean) {
    this.writePropertyWhenValid(s => s.border.isEnable = value);
  }

  kindOptions: StandardOption<number>[] = [
    new StandardOption<number>("レ点", CheckStyleKinds.Check),
    new StandardOption<number>("塗り潰し", CheckStyleKinds.Fill),
  ];

  // 初期値「表示する」
  get boderOptions(): StandardOption<boolean>[] {
    return [
      new StandardOption<boolean>("表示", true),
      new StandardOption<boolean>("非表示", false),
    ];
  }
}
